import { useState, useEffect, useMemo } from 'react';
import { useUserStore, useConnectStore } from '../../store/models';
import { useHistory } from 'react-router-dom';
import { getMeetConnectDismissed, setMeetConnectDismissed } from '../../utils';

function useMeetConnectBanner() {
    const userStore = useUserStore();
    const connectStore = useConnectStore();
    const history = useHistory();

    const userEmail = userStore.user?.email;
    const [dismissed, setDismissed] = useState(() => getMeetConnectDismissed(userEmail));

    // Re-check dismissed state once the user resolves (on refresh it may be undefined on first render).
    // `user` is non-observable, so we key the effect on the observable `observed.user` token to react.
    useEffect(() => {
        const email = userStore.user?.email;
        if (email) {
            setDismissed(getMeetConnectDismissed(email));
        }
        // eslint-disable-next-line
    }, [userStore.observed.user]);

    useEffect(() => {
        if (userStore.publisher?.token) {
            connectStore.getCurrentPlan();
        }
        // eslint-disable-next-line
    }, [userStore.observed.publisher]);

    const hasActivePlan = !!connectStore.currentPlan;
    // Only known once getCurrentPlan resolves; gate on it so subscribers never see
    // the banner (currentPlan defaults to null before the call returns).
    const plansResolved = !!connectStore.observed.currentPlan;

    // currentPlan is non-observable; reading the observed token (bumped by
    // getCurrentPlan) in the deps array subscribes the observer,
    // so the banner re-evaluates when the plan call resolves.
    const showBanner = useMemo(
        () => !dismissed && plansResolved && !hasActivePlan,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [dismissed, plansResolved, hasActivePlan, connectStore.observed.currentPlan]
    );

    function handleExplore() {
        history.push('/admin/analytics/connect');
    }

    function handleDismiss() {
        setMeetConnectDismissed(userEmail);
        setDismissed(true);
    }

    return { showBanner, handleExplore, handleDismiss };
}

export default useMeetConnectBanner;
